import ReactDOM from 'react-dom'
import './index.css'
import './i18n/index'
import { App } from './App'

console.log('Cart v1.0.0')

ReactDOM.render(<App/>, document.getElementById('root'))
